// Client-side variant of server-side urlToPage. Works without server globals.
export function urlToPage(pageId, hash = "") {
  const host = (typeof window !== 'undefined' && window.location && window.location.origin)
    ? window.location.origin
    : '';

  // Get language & locale from data attributes or URL. Fallback to en-us.
  const documentElement = typeof document !== 'undefined' ? document.documentElement : null;
  let locale = documentElement?.getAttribute('data-hy-locale') || '';
  let language = documentElement?.getAttribute('data-hy-language') || '';

  if (!locale || !language) {
    const pathMatch = (typeof window !== 'undefined' && window.location && window.location.pathname)
      ? window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})\//i)
      : null;
    if (pathMatch) {
      language = pathMatch[1];
      locale = pathMatch[2];
    } else {
      language = 'en';
      locale = 'us';
    }
  }

  const base = `${host}/${language}-${locale}`;

  if (pageId === 'home') {
    return `${base}/${hash}`;
  } else {
    return `${base}/${pageId}/${hash}`;
  }
}